export const HIDE_AVATAR_FOR_MESSAGE = 'HIDE_AVATAR_FOR_MESSAGE';
export const SHOW_AVATAR_FOR_MESSAGE = 'SHOW_AVATAR_FOR_MESSAGE';
